export class ConceptualModelPrimitiveType {
    dataType = null;
    languageStringRequiredLanguages = null;
    regex = null;
    /**
     * Set of examples of values of this property.
     */
    example = null;
    isAttribute() {
        return true;
    }
    isAssociation() {
        return false;
    }
}
export class ConceptualModelComplexType {
    /**
     * We do not store reference to a class to allow for simple
     * serialization.
     */
    pimClassIri = null;
    isAttribute() {
        return false;
    }
    isAssociation() {
        return true;
    }
}
//# sourceMappingURL=conceptual-model-type.js.map